import styled from 'styled-components'
import Flex from 'components/Flex'
import Drawer from 'components/Drawer'
import { Form,Radio as AntdRadio, Form as AntdForm,Radio } from 'antd'
export const FormItem = styled(AntdForm.Item)`
  margin-bottom: ${props =>
    props.marginbottom ? props.marginbottom : '0px'} !important;
  width: 100%;
  .ant-form-item-explain-error {
    padding-left: ${props => (props.padding ? '15%' : '0')};
  }
`
export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    &::-webkit-scrollbar {
      display: '';
    }
  }
  .ant-drawer-title {
    font-weight: 700;
  }
`
export const FooterFlex = styled(Flex)`
  gap: 20px;
`
export const FormWrapper = styled(Form)`
  width: 100%;
`

export const UploadText = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #3249d7;
  cursor: pointer;
 
`
export const FileInput = styled.input`
  opacity: 0;
  display: block;
  width: 100px;
  position: relative;
  top: -30px;
`
export const AddIcon = styled.div`
  margin-top: 5px;
  margin-right: 5px;
  cursor: pointer;
`
export const Heading = styled.div`
  font-weight: 600;
  font-size: 1.1428571428571428em;
  line-height: 21px;
  color: #1b1f22;
`
export const RadioGroup = styled(Radio.Group)`
  display: flex;
  width: 85%;
`

export const RadioGroupNew = styled(AntdRadio.Group)`
  display: flex;
  gap: ${props => (props.gap ? props.gap : '15px')};
  margin-top: 8px;
  ${props => props?.spaceBetween && 'justify-content: space-between;'}
`

export const LocalDiv = styled(Flex)`
  width: 100%;
  background: #ffffff;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
  padding: 10px;
  margin-top: 2px;
  cursor: pointer;
`
export const DrawerListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-top: 10px;
`;
